module.exports = __webpack_public_path__ + "img/lattea.a90868bc.jpg";